
      import UserFilled from './user-filled.vue'
      import type { App, Plugin } from 'vue'

      export const UserFilledPlugin: Plugin = {
        install(app: App) {
          app.component('UserFilled', UserFilled)
        },
      }
      export { UserFilled }
      